import { TemplateConfig } from '../types';

export const sincereHeartSpreadConfig: TemplateConfig = {
  id: 'sincere-heart-spread',
  name: '是否真心牌阵',
  description: '分析对方在感情中的真实心态',
  cardCount: 8,

  fieldDefaults: {
    title: '是否真心牌阵',
    customerQuestion: '分析对方在感情中的心态。',
    cardPlaceholders: [
      '请输入第 1 列第 1 张牌',
      '请输入第 1 列第 2 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 3 列第 2 张牌',
      '请输入第 2 列第 1 张牌',
      '请输入第 2 列第 3 张牌',
      '请输入第 2 列第 2 张牌 下方的牌',
      '请输入第 2 列第 2 张牌 上方的牌'
    ],
    cardInfos: [
      '对方对你是否真心',
      '对方的真实面目',
      '对方对你的真实想法',
      '对方认为的感情现状',
      '对方身边的人对你的看法',
      '对方对你有什么隐藏的(如果有则说明)',
      '对方是否背叛过这段感情',
      '对方未来在这段关系中的样子'
    ]
  },

  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],

  generateOptions: {
    normal: true,
    thinking: true
  },

  ui: {
    color: '#ff7a45',
    backgroundColor: '#fff2e8',
    icon: '💗'
  }
};
